export default {
  state: {
    trend: 7, // 趋势图tab的value
    calendar: 'month', // 日历tab
    startTime: '', // 当周或者当月起始时间
    endTime: '',
    // 近几天起始时间
    startDate: '',
    endDate: '',
  },

  reducers: {
    setState(prevState, state) {
      return {
        ...prevState,
        ...state,
      };
    },

  },

  effects: (dispatch) => ({}),
};

